export default function SectionContainer({ children }) {
  return <div>{children}</div>
}
